import { DEFAULT_COMPETENCE_VISIBLE_ITEMS } from "modules/PsyProfile/common/constants"
import { Competence } from "utils/interfaces"

export function getColumnCompetences(
    competences: Competence[],
    columnsCount: number,
    columnIndex: number,
    isOpen: boolean
) {
    const columnCompetences = Array.from(competences.keys())
        .filter((index) => index % columnsCount === columnIndex)
        .map((index) => competences[index])
    if (isOpen) return columnCompetences
    return columnCompetences.slice(0, DEFAULT_COMPETENCE_VISIBLE_ITEMS)
}

export function sortCompetence(
    reportedProblemsNumbers: number[],
    psyCompetences: Competence[]
): Competence[] {
    const sortedCompetences = [...psyCompetences]

    sortedCompetences.sort((a, b) => {
        const indexA = reportedProblemsNumbers.indexOf(a.id)
        const indexB = reportedProblemsNumbers.indexOf(b.id)

        if (indexA === -1 && indexB !== -1) return 1
        if (indexB === -1 && indexA !== -1) return -1

        if (indexA !== -1 && indexB !== -1) return indexA - indexB

        return 0
    })

    return sortedCompetences
}
